import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextareaAutosize } from '@mui/material'
import Editor from 'components/editor'

const CreateModal = ({ handleRefresh }) => {
  const uploadImage = useUploadImage()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description, setDescription] = useState('')
  const [images, setImages] = useState([])

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files)
    setImages(files)
  }

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };
  // console.log(svgIcon, "svgIcon")
  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }


  const handleSubmit = async (e) => {

    e.preventDefault();
    setProcessing(true);
    let uploadedImages = []

    if (images.length > 0) {
      try {
        const uploadPromises = images.map((file) =>
          uploadImage({ file, desiredPath: `app/logo/image` })
        )
        const responses = await Promise.all(uploadPromises)
        uploadedImages = responses.map((res) => res?.response?.data).filter(Boolean)
      } catch (error) {
        console.error('Image upload failed:', error)
      }
    }
    const payload = {
      name: e.target.name.value,
      description,
      snapshotLink: e.target.snapshotLink.value,
      image: uploadedImages,
      video: e.target.video.value,
    };

    console.log(payload, "payload");

    const { response } = await AppService.snap_shot.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
      setImages([])
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} >
            <MDTypography variant="h5" mb={2}>
              Create Snapshots
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">SnapShot Link</MDTypography>
              <MDInput label="SnapShot Link" name="snapshotLink" fullWidth />

            </MDBox>
              <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Images +
                <input hidden name="image" type="file" multiple onChange={handleFileChange} />
              </Button>
            </Stack>
            
            {images.length > 0 && (
              <MDBox mt={2}>
                <MDTypography variant="button">Selected Images:</MDTypography>
                <Stack direction="row" spacing={1} mt={1}>
                  {images.map((file, index) => (
                    <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                      <img
                        src={file instanceof File ? URL.createObjectURL(file) : file}
                        alt={`preview-${index}`}
                        width={50}
                        height={50}
                        style={{ borderRadius: 5 }}
                      />
                      <button
                        type="button"
                        onClick={() => handleRemoveImage(index)}
                        style={{
                          position: 'absolute',
                          top: -5,
                          right: -5,
                          background: 'rgba(255, 132, 132, 0.7)', // Make the background slightly transparent
                          color: 'red',
                          border: 'none',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          width: 20,
                          height: 20,
                          fontSize: '16px',
                          lineHeight: '16px', // Center the 'x' in the button
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  ))}
                </Stack>
              </MDBox>
            )}
           <MDBox mb={2}>
              <MDTypography variant="button">Video Url</MDTypography>
              <MDInput label="Video Url" name="video" fullWidth />
            </MDBox>


            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
